import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { errorMessage } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";

// « Voir mon aperçu »: the summary of the person looking, written now from their own rights — never anyone else's. « Me l'envoyer » delivers it
// to them (bell, and WhatsApp when they have it on) so the real message can be checked on their phone.
export default function WeeklySummaryPreview() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [summary, setSummary] = useState(null);

  const load = async () => {
    setOpen(true);
    setSummary(null);
    setLoading(true);
    try {
      const { data } = await api.post("/weekly-summary/preview", {});
      setSummary(data);
    } catch (e) {
      toast.error(errorMessage(e));
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  const send = async () => {
    setSending(true);
    try {
      await api.post("/weekly-summary/preview", { send: true });
      toast.success("Aperçu envoyé : regardez votre cloche et votre WhatsApp.");
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Button type="button" variant="outline" size="sm" onClick={load} data-testid="weekly-preview">Voir mon aperçu</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-lg" data-testid="weekly-preview-dialog">
          <DialogHeader>
            <DialogTitle className="text-left">Votre résumé de la semaine</DialogTitle>
            <DialogDescription className="text-left">Tel qu'il serait écrit maintenant, avec vos droits.</DialogDescription>
          </DialogHeader>
          {loading && <div className="flex justify-center py-8"><Loader2 className="animate-spin text-jamora" /></div>}
          {summary && (
            <div className="space-y-2">
              <pre className="whitespace-pre-wrap break-words font-sans text-sm text-slate-900 bg-slate-50 border border-slate-200 rounded-lg p-3 max-h-[50vh] overflow-y-auto" data-testid="weekly-preview-text">{summary.text}</pre>
              <p className="text-xs text-slate-500" data-testid="weekly-preview-source">{summary.ai ? "Rédigé par le Copilote." : "Texte factuel (le Copilote n'a pas pu le rédiger)."}</p>
            </div>
          )}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => setOpen(false)}>Fermer</Button>
            <Button type="button" onClick={send} disabled={!summary || sending} data-testid="weekly-preview-send">
              {sending && <Loader2 size={14} className="animate-spin mr-1.5" />}Me l'envoyer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
